export const MESSAGE_TYPES = {
  WIDGET_READY: "WIDGET_READY",
  CLOSE_WIDGET: "CLOSE_WIDGET",
  RESIZE_WIDGET: "RESIZE_WIDGET",
  TRACK_EVENT: "TRACK_EVENT",
  TRACK_ERROR: "TRACK_ERROR",
  ERROR: "ERROR",
} as const;

export type MessageType = (typeof MESSAGE_TYPES)[keyof typeof MESSAGE_TYPES];

export interface WidgetMessage {
  type: MessageType;
  payload?: unknown;
}

export interface ResizePayload {
  height: number;
}

export interface ErrorPayload {
  message: string;
}

export interface TrackEventPayload {
  eventName: string;
  attributes?: Record<string, string | number | boolean>;
}

export interface TrackErrorPayload {
  error: {
    message: string;
    stack?: string;
  };
  attributes?: Record<string, string | number | boolean>;
}

const ALLOWED_MESSAGE_TYPES = new Set<string>(Object.values(MESSAGE_TYPES));

export function isValidWidgetMessage(data: unknown): data is WidgetMessage {
  if (typeof data !== "object" || data === null) {
    return false;
  }

  const record = data as Record<string, unknown>;
  if (typeof record.type !== "string") {
    return false;
  }

  return ALLOWED_MESSAGE_TYPES.has(record.type);
}
